import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConfigProvider, theme } from "antd";
import App from "./App";
import "./styles.css";

const container = document.getElementById("root"); // The root element in your HTML
const root = createRoot(container);

root.render(
  <StrictMode>
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        components: {
          Button: { colorPrimary: "#6a6a6a", algorithm: true },
          Input: { colorPrimary: "#6a6a6a", algorithm: true },
          Tabs: { colorPrimary: "#ffff00", algorithm: true },
          Spin: { colorPrimary: "#ffff00", algorithm: true },
          // Collapse: {
          //   // headerPadding: "-10px",
          //   // contentPadding: "-10px",
          //   // colorText: "#ffff00",
          //   // fontSize: "16px",
          //   // fontFamily: "Chakra Petch, sans-serif",
          //   // algorithm: true,
          // },
          // Card: {
          //   colorPrimary: "#ffff00",
          //   // colorText: "#ffff00",
          //   // fontFamily: "Chakra Petch, sans-serif",
          //   // algorithm: true,
          // },
        },
      }}
    >
      <App />
    </ConfigProvider>
  </StrictMode>
);
